export const locales = ['en', 'fr', 'zh', 'ja', 'ru', 'es', 'de', 'it', 'ko', 'hi', 'ar', 'pt', 'id'] as const;
export const defaultLocale = 'en' as const;
export type Locale = (typeof locales)[number];

export const localeNames: Record<Locale, string> = {
	ar: 'العربية',
	de: 'Deutsch',
	en: 'English',
	es: 'Español',
	fr: 'Français',
	hi: 'हिन्दी',
	id: 'Bahasa Indonesia',
	it: 'Italiano',
	ja: '日本語',
	ko: '한국어',
	pt: 'Português',
	ru: 'Русский',
	zh: '中文',
};

const rtlLocales: readonly string[] = ['ar'] as const;
export function isRtlLocale(locale: string): boolean {
	return (rtlLocales as readonly string[]).includes(locale);
}
